var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWristband(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 189.5 67 C 217.39 67 240 89.61 240 117.5 C 240 145.39 217.39 168 189.5 168 C 161.61 168 139 145.39 139 117.5 C 139 89.61 161.61 67 189.5 67 Z",
    fill: "rgb(240, 240, 240)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 99.662 79.549 C 104.596 67.884 111.735 57.379 120.557 48.557 C 138.201 30.913 162.576 20 189.5 20 C 202.962 20 215.787 22.728 227.451 27.662",
    fill: "transparent",
    stroke: "rgb(1, 157, 201)",
    strokeDasharray: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.5 148.5 C 38.616 126.434 80.25 118.5 129.5 109 C 141.813 106.625 160 104.25 177 97.5",
    fill: "transparent",
    stroke: "#263032"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 301.5 103.5 C 303.625 103.5 309.75 103 308.5 106 C 307.25 109 298.688 115.813 297 117.5 C 295.313 119.188 291.5 123.75 285.5 125 C 279.5 126.25 271.706 130.349 268.5 131.5 C 265.294 132.651 251 134 241 134 C 231 134 226.75 133.125 217.5 136",
    fill: "transparent",
    stroke: "rgb(38, 48, 50)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 260.5 61.5 C 262.25 61.5 267.188 62.188 268 63",
    fill: "transparent",
    strokeWidth: 0.5,
    stroke: "rgb(38, 48, 50)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 286.5 83 C 284.438 85.063 281.5 88 281.5 88",
    fill: "transparent",
    strokeWidth: 0.5,
    stroke: "rgb(38, 48, 50)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 204 92.5 C 201.938 94.563 197.5 95 197.5 95",
    fill: "transparent",
    strokeWidth: 0.5,
    stroke: "rgb(38, 48, 50)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 237 122.5 C 228.25 121 216 125.5 216 125.5",
    fill: "transparent",
    strokeWidth: 0.5,
    stroke: "rgb(38, 48, 50)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 84 183.5 C 100.453 186.585 111 211 111 211",
    fill: "transparent",
    strokeWidth: 0.5,
    stroke: "rgb(38, 48, 50)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 196 142.5 C 184.5 147.141 166.875 156 156 161.5 C 134.25 172.5 116.75 188 100 193.5",
    fill: "transparent",
    stroke: "rgb(38, 48, 50)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 191 91.5 C 194.992 89.582 206.938 84.188 209 83 C 217.25 78.25 217.25 73.75 225 68.5 C 232.75 63.25 237.375 61.125 240 58.5 C 242.625 55.875 246.5 52.5 249.5 52.5 C 252.5 52.5 268 57.25 268 59.5 C 268 61.75 267.5 62 267.5 62 C 267.5 62 272.875 62.875 275 65 C 277.125 67.125 277 72.5 278 73.5 C 279 74.5 282.375 72.875 285.5 75 C 288.625 77.125 288.875 84.875 290 86 C 291.125 87.125 296.625 86.625 298 88 C 298.688 88.687 300.625 103.375 299 105 C 297.375 106.625 295.75 109.25 286.5 115.5",
    fill: "transparent",
    stroke: "#263032"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(171.039 90.478) rotate(2 20.527 27.795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.462 7.791 C 23.199 7.353 22.649 7.183 22.185 7.397 L 11.012 12.554 C 10.472 12.804 10.267 13.467 10.573 13.977 L 11.038 14.752 C 11.301 15.19 11.851 15.359 12.315 15.145 L 23.488 9.988 C 24.028 9.739 24.233 9.076 23.927 8.566 Z",
    fill: "rgb(251, 251, 250)",
    stroke: "rgb(1, 157, 201)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.462 35.291 C 38.199 34.853 37.649 34.683 37.185 34.897 L 26.012 40.054 C 25.472 40.304 25.267 40.967 25.573 41.477 L 26.038 42.252 C 26.301 42.69 26.851 42.859 27.315 42.645 L 38.488 37.488 C 39.028 37.239 39.233 36.576 38.927 36.066 Z",
    fill: "rgb(251, 251, 250)",
    stroke: "rgb(1, 157, 201)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11 12.521 C 2.839 -2.124 0 9.646 0 9.021 C -0 8.396 0.665 2.698 12.5 0.021 C 15.61 -0.087 18.024 -0.047 22 7.021",
    fill: "transparent",
    stroke: "rgb(1, 157, 201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24 10.021 L 38 35.021",
    fill: "transparent",
    stroke: "rgb(1, 157, 201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.5 15.521 L 24.5 37.521",
    fill: "transparent",
    stroke: "rgb(1, 157, 201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 39 37.021 C 43.5 46.396 39.369 48.792 38.244 49.917 C 25.673 58.861 21.394 54.508 21.394 54.508 C 21.394 54.508 24.563 56.738 27.408 54.798 C 30.252 52.859 31 51.584 27 42.521",
    fill: "transparent",
    stroke: "rgb(1, 157, 201)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 279.338 155.451 C 274.404 167.116 267.265 177.621 258.443 186.443 C 240.799 204.087 216.424 215 189.5 215 C 176.038 215 163.213 212.272 151.549 207.338",
    fill: "transparent",
    stroke: "rgb(1, 157, 201)",
    strokeDasharray: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 263 117.5 C 263 158.093 230.093 191 189.5 191 C 169.204 191 150.829 182.773 137.528 169.472 C 124.227 156.171 116 137.796 116 117.5 C 116 76.907 148.907 44 189.5 44",
    fill: "transparent",
    stroke: "rgb(1, 157, 201)",
    strokeDasharray: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWristband);
export default __webpack_public_path__ + "static/media/wristband.3978a55ea4ff640654886588df591de1.svg";
export { ForwardRef as ReactComponent };